import { bakeHtml, type BakeInput } from '@/lib/export-html';

/**
 * Open the baked HTML in a hidden iframe and call print() on its window. The browser's
 * print dialog handles the rest. Interactive elements don't carry into PDF (per FR-10.2);
 * the caller is expected to surface that warning before invoking this.
 */
export function exportToPdf(input: BakeInput): void {
  const baked = bakeHtml(input);
  const iframe = document.createElement('iframe');
  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  iframe.setAttribute('aria-hidden', 'true');
  document.body.appendChild(iframe);

  const cleanup = () => {
    setTimeout(() => iframe.remove(), 1000);
  };

  iframe.addEventListener('load', () => {
    try {
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();
    } finally {
      cleanup();
    }
  });

  iframe.srcdoc = baked;
}
